/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_TERMINATED_LABELER_DISPALY =
  'REFRESH_TERMINATED_LABELER_DISPALY';
export const SET_TERMINATED_LABELER_REPORT = 'SET_TERMINATED_LABELER_REPORT';
export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_TERMINATED_LABELER = 'REFRESH_TERMINATED_LABELER';
